import React, {useEffect} from 'react'
import {useNavigate, useLocation} from 'react-router-dom'
import usaflag from '../../../assets/countries/united_state_flag.svg'
import canflag from '../../../assets/countries/canada_flag.svg'
import gbflag from '../../../assets/countries/great_britain_flag.svg'
import nzflag from '../../../assets/countries/newzealand_flag.svg'
import auflag from '../../../assets/countries/australia_flag.svg'
import vietnamFlag from '../../../assets/countries/vietnam_flag.svg'
import spainFlag from '../../../assets/countries/spain-flag.svg'
import italyFlag from '../../../assets/countries/italy-flag.svg'
import indiaFlag from '../../../assets/countries/india-flag.svg'
import philippinesFlag from '../../../assets/countries/philippines-flag.svg'
import greeceFlag from '../../../assets/countries/greece-flag.svg'

import {
  CountrySelectionContainer,
  CountrySelectionWrapper,
  CountrySelectionHeader,
  CountrySelectionTitle,
  CountryButtonsContainer,
  CountryButton,
  CountryFlagImage,
  CountryButtonContent,
  CountryButtonText,
  DecorativeElement,
} from './kp-country-selection-styles'
import {useSelector} from 'react-redux'
import {useAuth0} from '@auth0/auth0-react'
import {selectedLinkType} from '../../../app-store/kpGlobalStateSlice'
import {selectPartnerAC} from '../../../app-store/selector'
import {MissingKeapPartnerIdModal} from '../kp-11-link/kp-11Link-layout'
import {getUserRoles} from '../../../utils/get-user-roles'
import {useUserFeatures} from '../../../context/user-features-context'

const COUNTRIES = [
  {
    name: 'United States',
    isoValue: 'US',
    img: usaflag,
    description: 'US & Territories',
  },
  {
    name: 'Canada',
    isoValue: 'CA',
    img: canflag,
    description: 'Canada',
  },
  {
    name: 'Great Britain',
    isoValue: 'GB',
    img: gbflag,
    description: 'Great Britain',
  },
  {name: 'Australia', isoValue: 'AU', img: auflag, description: 'Australia'},
  {
    name: 'New Zealand',
    isoValue: 'NZ',
    img: nzflag,
    description: 'New Zealand',
  },
  {name: 'Spain', isoValue: 'ES', img: spainFlag, description: 'Spain'},
  {name: 'Italy', isoValue: 'IT', img: italyFlag, description: 'Italy'},
  {name: 'India', isoValue: 'IN', img: indiaFlag, description: 'India'},
  {
    name: 'Philippines',
    isoValue: 'PH',
    img: philippinesFlag,
    description: 'Philippines',
  },
  {name: 'Vietnam', isoValue: 'VN', img: vietnamFlag, description: 'Vietnam'},
  {name: 'Greece', isoValue: 'GR', img: greeceFlag, description: 'Greece'},
]

export const KPCountrySelectionComponent = ({keapPartnerId, userData}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const navLinkType = location.state?.linkType || '1:many'
  //const keapPartnerId = location.state?.keapPartnerId
  const linkType = useSelector(selectedLinkType) || navLinkType
  const partnerAffiliateCode = useSelector(selectPartnerAC)
  const {user} = useAuth0()
  const userRoles = userData?.user_roles || getUserRoles(user)
  const isInfluencerOps = userRoles.includes('InfluencerOps')
  const {Enable_GB_Loc_Access} = useUserFeatures()

  // 1:Many no longer has a country page (the catalog has a country dropdown);
  // anyone who still lands here for it is forwarded to the catalog.
  useEffect(() => {
    if (linkType === '1:many') {
      navigate('/keap-partner-catalog', {
        replace: true,
        state: {linkType, selectedCountry: 'US', keapPartnerId},
      })
    }
  }, [linkType, keapPartnerId, navigate])

  console.log('=== KPCountrySelectionComponent Debug ===')
  console.log('location.state:', location.state)
  console.log('linkType:', linkType)
  console.log('keapPartnerId:', keapPartnerId)

  // Validate Keap Partner ID before allowing user to proceed.
  // Sources mirror kp-11Link-generateUrl.js priority ladder:
  //   1. InfluencerOps → user_metadata.networkId
  //   2. Switched/native KeapPartner → partnerAffiliateCode (Redux)
  //   3. URL ?pac= / sessionStorage → keapPartnerId (Redux user slice)
  //   4. Salesforce-sourced metadata → user_metadata.keapPartnerId
  const partnerIdFromMetadata = userData?.user_metadata?.keapPartnerId
  if (
    !isInfluencerOps &&
    !keapPartnerId &&
    !partnerIdFromMetadata &&
    !partnerAffiliateCode
  ) {
    return <MissingKeapPartnerIdModal />
  }

  const handleCountrySelect = country => {
    if (linkType === '1:1') {
      navigate('/keap-partner-account', {
        state: {
          linkType: linkType,
          selectedCountry: country,
          keapPartnerId: keapPartnerId,
        },
      })
    } else {
      navigate('/keap-partner-catalog', {
        state: {
          linkType: linkType,
          selectedCountry: country,
          keapPartnerId: keapPartnerId,
        },
      })
    }
  }

  return (
    <CountrySelectionContainer>
      <CountrySelectionWrapper>
        <DecorativeElement className="top-left" />
        <DecorativeElement className="bottom-right" />

        <CountrySelectionHeader>
          <CountrySelectionTitle>
            Where are you selling Thryv?
          </CountrySelectionTitle>
        </CountrySelectionHeader>

        <CountryButtonsContainer>
          {COUNTRIES.filter(
            country => country.name !== 'Great Britain' || Enable_GB_Loc_Access,
          ).map(country => (
            <CountryButton
              key={country.isoValue}
              onClick={() => handleCountrySelect(country.isoValue)}
              aria-label={`Select ${country.name}`}
            >
              {country.img && (
                <CountryFlagImage
                  src={country.img}
                  alt={`${country.name} flag`}
                />
              )}
              <CountryButtonContent>
                <CountryButtonText>{country.name}</CountryButtonText>
              </CountryButtonContent>
            </CountryButton>
          ))}
        </CountryButtonsContainer>
      </CountrySelectionWrapper>
    </CountrySelectionContainer>
  )
}
